// frontend/src/components/dashboard/admin/UploadReports.js
import React from 'react';

const UploadReports = () => {
    return (
        <div className="upload-reports">
            <h2>📋 Upload Reports</h2>
            <p>View certificate upload history and reports (Component under development)</p>
        </div>
    );
};

export default UploadReports;